import React, { useEffect } from 'react'

import { CreateCustomerForm, CreateCustomerPageHeader } from '@/components/pages/Customer/Create'
import { useWashingMethods } from '@/pages/WashMethods/WashingMethod.hooks'

import { useCreateCustomer } from './Create.hooks'

const CreateCustomer = () => {
  const { createCustomer, loading } = useCreateCustomer()

  const { getAllWashingMethods, washingMethods } = useWashingMethods()

  useEffect(() => {
    getAllWashingMethods()
  }, [getAllWashingMethods])

  return (
    <>
      <CreateCustomerPageHeader />
      <CreateCustomerForm {...{ loading, washingMethods }} onSubmit={createCustomer} />
    </>
  )
}

CreateCustomer.displayName = 'CreateCustomer'
export default CreateCustomer
